import { ReactNode, useEffect, useState } from 'react';

type CSRProps = {
  children: ReactNode;
};

function CSR({ children }: CSRProps) {
  const [renderingType, setRenderingType] = useState<'SSR' | 'CSR'>('SSR');

  useEffect(() => {
    setRenderingType('CSR');
  }, []);

  return renderingType === 'CSR' ? <>{children}</> : <></>;
}

export default CSR;
